interface Props {
  keepDuplicates: boolean;
  setKeepDuplicates: (value: boolean) => void;
  nearDuplicateMinutes: number;
  setNearDuplicateMinutes: (value: number) => void;
}

export function OptionsPanel({ keepDuplicates, setKeepDuplicates, nearDuplicateMinutes, setNearDuplicateMinutes }: Props) {
  return (
    <section className="card compact-card">
      <h2>Opções</h2>
      <label className="checkbox-row">
        <input type="checkbox" checked={keepDuplicates} onChange={(event) => setKeepDuplicates(event.target.checked)} />
        <span>Modo compatibilidade: manter duplicatas exatas</span>
      </label>
      <label className="field-row">
        <span>Alerta de batidas próximas</span>
        <input
          type="number"
          min={0}
          max={60}
          value={nearDuplicateMinutes}
          onChange={(event) => setNearDuplicateMinutes(Number(event.target.value))}
        />
        <small>minutos</small>
      </label>
    </section>
  );
}
